
import { Input } from 'ant-design-vue';
import notification from 'ant-design-vue/lib/notification';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ResetPassword',
  components: {
    Input,
  },
  data() {
    return {
      awaitingResponse: false,
      email: '',
    };
  },
  computed: {
    loginLocation() {
      return {
        path: '/login',
        query: { ...this.$route.query },
      };
    },
  },
  methods: {
    async submit() {
      try {
        await this.$store.dispatch('user/resetUserPassword', { email: this.email });
        notification.success({
          message: `An email has been sent to ${this.email} with further instructions.`,
        });
        this.email = '';
        this.$router.push({ name: 'Login' });
      } catch (e) {
        notification.error({
          message: 'Reset process failed!',
        });
      }
    },
  },
});
